import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import Menu from './Menu';
import Navbar from './Navbar';

const Header = ({hide}) => {
  const { isNavbarCategoryOpen, setIsNavbarCategoryOpen } = useContext(AppContext);

  return (
    <header className='header'>
      <Navbar />
      <div className="dd-menus-overlay" style={isNavbarCategoryOpen ? { display: "block" } : { display: "none" }} onClick={() => setIsNavbarCategoryOpen(prevState => !prevState)}></div>
      {hide&&<Menu />}
    </header>
  )
}

export default Header
